import { Checkbox, Text } from "@mantine/core";
import { HiCheck } from "react-icons/hi";
import { useTranslation } from "react-i18next";

interface IProps {
  notNeedConfirm: boolean;
  handleNotNeedConfirm: () => void;
}

export default function NotNeedConfirm({
  notNeedConfirm,
  handleNotNeedConfirm,
}: IProps) {
  const { t } = useTranslation();

  return (
    <Checkbox
      color="primary.1"
      size="sm"
      icon={HiCheck}
      onChange={handleNotNeedConfirm}
      checked={notNeedConfirm}
      label={<Text>{t("global.predictives_buy_card.need_confirm")}</Text>}
      styles={{
        inner: {
          height: "16px",
          width: "16px",
        },
        input: {
          height: "16px",
          width: "16px",
          borderRadius: "4px",
        },
        label: {
          fontSize: "12px",
          fontWeight: 500,
        },
      }}
    />
  );
}
